// extracted by css-extract-rspack-plugin
export default {"readOnlySection":"rOIsGvGL_v8cEAMu","isReadOnly":"mu1mKgjR8pcz00eX","clickable":"YrfjOG4FZ0M_xHTc"};